if (!customElements.get('accordion-tab')) {
  customElements.define(
    'accordion-tab',
    class AccordionTab extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const isMobile = window.innerWidth < 540;

        const tabHeading = this.querySelector('.tab-heading');
        const tabLabels = Array.from(this.querySelectorAll('.tab-label'));
        const tabPanels = Array.from(this.querySelectorAll('.tab-panel'));

        if (isMobile && tabHeading && tabLabels.length === tabPanels.length) {
          tabHeading.innerHTML = '';
          tabLabels.forEach((label, index) => {
            const panel = tabPanels[index];
            tabHeading.appendChild(label);
            tabHeading.appendChild(panel);

            label.addEventListener('click', () => {
              const isActive = panel.classList.contains('active');
              tabPanels.forEach(p => p.classList.remove('active'));
              tabLabels.forEach(l => l.classList.remove('active'));

              if (!isActive) {
                panel.classList.add('active');
                label.classList.add('active');
              }
            });
          });
        } else {
          tabLabels.forEach((lbl, index) => {
            lbl.addEventListener('click', () => {
              tabPanels.forEach((panel, panelIndex) => {
                panel.classList.toggle('active', panelIndex === index);
              });

              tabLabels.forEach((label) => label.classList.remove('active'));
              tabLabels[index].classList.add('active');
            });
          });
        }
      }
    }
  );
}
